module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"headerTooltip":"Wykres prezentuje średnią cenę w w czasie w sklepach wyświetlanych w widgecie (domyślne ustawienia). Aby sprawdzić średnią cenę w czasie w pozostałych sklepach, użyj filtra Wybrane sklepy. Wartość ta, jest obliczana jako suma cen ze wszystkich dni, podzielona przez liczbę dni, dla których dostępna jest informacja o cenie i jest ona wyższa niż 0."}}')
  delete Component.options._Ctor
}
